import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { formatCounterAmount } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'

import type AllowanceIncidence from 'modules/timeoff/store/models/AllowanceIncidence'

interface IncidenceProps {
  allowanceIncidence: AllowanceIncidence
  isHourlyFixedBalance: boolean
}

const Incidence = ({ allowanceIncidence, isHourlyFixedBalance }: IncidenceProps) => {
  const days = allowanceIncidence.attributes.days_in_cents / 100
  const sign = days > 0 ? '+' : ''
  const formattedDays = formatCounterAmount(days, isHourlyFixedBalance)

  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal color="grey000White">
          {i18n.t('time_off.allowance_tooltip.holiday')}
        </Text.Normal>
        <Text.Normal color="grey000White">{`${sign}${formattedDays}`}</Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="flexStart" textAlign="left">
        <Text.Normal size="200" color="grey000White">
          {allowanceIncidence.attributes.description}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(Incidence)
